export enum PlotType {
    SCATTER_PLOT = 'scatter-plot',
    SURFACE_PLOT = 'surface-plot',
    RECIPE_DISTRIBUTION = 'recipe-distribution',
    PIVOT_ANALYSIS = 'pivot-analysis',
    VISUALIZE_DISTRIBUTION = 'visualize-distribution'
}